import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Link from 'gatsby-link'
import classnames from 'classnames'
import { indexMap } from '@helpers'
import { ReactComponent as LeftArrow } from '@assets/svgs/icons/left_arrow-white.svg'
import { ReactComponent as RightArrow } from '@assets/svgs/icons/right_arrow-white.svg'
import './NavigationLink.module.scss'

class NavigationLink extends Component {
  state = {
    submenuEnabled: false
  }

  onClick = () => {
    const { click } = this.props
    click()
    click && this.toggleSubmenu()
  }

  toggleSubmenu = () => {
    const { submenuEnabled } = this.state
    this.setState({ submenuEnabled: !submenuEnabled })
  }

  renderSubmenu = (menu) => {
    const { submenuEnabled } = this.state

    return (
      <div styleName={classnames('submenu', { 'enabled': submenuEnabled })}>
        <span onClick={this.toggleSubmenu} styleName='back'>
          <LeftArrow styleName='arrow' /> Back
        </span>
        <ul styleName='sublinks'>
          {indexMap(({ link, title }, index) => (
            <li key={`submenu-${index}`} styleName='subitem'>
              <Link
                to={`/${R.propOr('', 'slug', link)}`}
                onClick={this.onClick}
                styleName='sublink'
              >
                {title}
              </Link>
            </li>
          ), menu)}
        </ul>
      </div>
    )
  }

  render () {
    const { item } = this.props
    const title = R.propOr('', 'title', item)
    const slug = R.pathOr('', ['link', 'slug'], item)
    const subMenu = R.propOr('', 'subMenu', item)
    const externalUrl = R.prop('externalLink', item)
    return (
      <li styleName='item'>
        {externalUrl ? (
          <Link to={externalUrl} onClick={this.onClick} styleName='link'>{title}</Link>
        ) : (
          <Link to={`/${slug}`} onClick={this.onClick} styleName='link'>{title}</Link>
        )}
        {subMenu && (
          <span onClick={this.toggleSubmenu} styleName='forward'>
            <RightArrow styleName='right-arrow' />
          </span>
        )}
        {subMenu && this.renderSubmenu(subMenu)}
      </li>
    )
  }
}

NavigationLink.propTypes = {
  item: PropTypes.object.isRequired,
  click: PropTypes.func
}

NavigationLink.defaultProps = {
  click: () => {}
}

export default NavigationLink



// WEBPACK FOOTER //
// ./src/components/MobileDropdown/MobileNavigation/NavigationLink/NavigationLink.js